import JSON5 from "json5";
import type {
  ValidationResponse,
  Validator,
} from "legacy/constants/WidgetValidation";
import type {
  DataTreeEntity,
  DataTree,
} from "legacy/entities/DataTree/dataTreeFactory";

export const STATE_VALUE_VALIDATION: Validator = (
  value: any,
  props: DataTreeEntity,
  _dataTree?: DataTree,
): ValidationResponse => {
  try {
    const parsedValue = JSON5.parse(value);
    return {
      isValid: true,
      parsed: parsedValue,
    };
  } catch (e) {
    return {
      isValid: true,
      parsed: value,
    };
  }
};
